import { withText } from './Text';
import { H2Title } from './Text.styles';

const SectionTitle = withText(H2Title);

SectionTitle.displayName = 'SectionTitle';

export { SectionTitle };
